
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiNumberInput from './vendors/farlo-ui-numberinput.js';
import FarloUiList from './vendors/farlo-ui-list.js';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar';
import addLightboxToGallery from './vendors/farlo-ui-gallery-lightbox.js';

// Import Footer Components
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { faqs } from './components/footer/faqs.js';
import { navigation, navicon } from './components/footer/navigation.js';
import { smoothScrollToAnchor } from './components/footer/smoothScrollToAnchor.js';
import { addScrolledClass } from './components/footer/addScrolledClass.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { gsapTransform } from './components/footer/videoScrollTrigger.js';
import { farloUiSlider } from './components/footer/flickity-gallery.js';
import { farloUiSliderAuto } from './components/footer/flickity-auto-slider.js';
import { farloUiMobileSlider } from './components/footer/flickity-mobile.js';
import { openingLoader } from './components/footer/openingLoader.js';
import { gsapParallax } from './components/footer/parallax-lights.js';
import { jumpToAccordion } from './components/footer/jumpToAccordion.js';
import { pagePopup } from './components/footer/pagePopup.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	function showListings() {
		const loadMoreButton = document.getElementById("load-more-press");
		let currentPage = parseInt(my_ajax_object.current_page);
		const maxPages = parseInt(my_ajax_object.max_pages);

		loadMoreButton.addEventListener("click", function (event) {
			event.preventDefault();
			currentPage++;

			if (currentPage > maxPages) {
				loadMoreButton.style.display = "none";
				return;
			}

			const formData = new FormData();
			formData.append("action", "load_more_press");
			formData.append("page", currentPage);

			// Disable button during fetch
			loadMoreButton.textContent = "Loading...";
			loadMoreButton.disabled = true;

			fetch(my_ajax_object.ajax_url, {
				method: "POST",
				body: formData
			})
				.then(response => response.text())
				.then(html => {
					const productionList = document.querySelector(".site-archive-list");
					productionList.insertAdjacentHTML("beforeend", html);

					// Restore button
					loadMoreButton.textContent = "Show More";
					loadMoreButton.disabled = false;

					// Hide if we've reached the last page
					if (currentPage >= maxPages) {
						loadMoreButton.style.display = "none";
					}
				})
				.catch(error => {
					console.error("Error loading more:", error);
					loadMoreButton.textContent = "Show More";
					loadMoreButton.disabled = false;
				});
		});
	}

	document.addEventListener('DOMContentLoaded', () => {

		if (document.querySelector('.site-archive')) {
			showListings();
		}

		if (document.querySelector('.farlo-lcc-loader')) {
			openingLoader();
		}

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.farlo-jump-accordion')) {
			jumpToAccordion();
		}

		if (document.querySelector('.gallery-slider__enable')) {
			document.querySelectorAll('.gallery-slider__enable').forEach((_sel) => {
				farloUiSlider(_sel);
			});
		}

		if (document.querySelector('.testimonial-slider__enable')) {
			document.querySelectorAll('.testimonial-slider__enable').forEach((_sel) => {
				farloUiSliderAuto(_sel);
			});
		}

		if (document.querySelector('.wp-block-query .is-layout-flow')) {
			document.querySelectorAll('.wp-block-query .wp-block-post-template.is-layout-flow').forEach((_sel) => {
				const wrap = _sel.closest('.wp-block-query');
				if (_sel.classList.contains('is-style-align-left') || (wrap && wrap.classList.contains('is-style-align-left'))) {
					farloUiSlider(_sel, 'left');
				} else {
					farloUiSlider(_sel, 'center');
				}

			});
		}

		if (document.querySelector('.farlo-ui-popup')) {
			pagePopup();
		}


		if (document.querySelector('.cards-slider__enable')) {
			document.querySelectorAll('.cards-slider__enable').forEach((_sel) => {
				farloUiMobileSlider(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.site-main')) {
			addScrolledClass();
		}

		if (document.querySelector('.is-style-lightbox-gallery')) {
			addLightboxToGallery();
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			const crmBlocks = document.querySelectorAll('.farlo-ui-crm[farlo-ui="crm"]');

			buttons.forEach(function (button) {
				let closestCrmBlock = null;
				let closestDistance = Infinity;

				crmBlocks.forEach(function (block) {
					const distance = button.getBoundingClientRect().top - block.getBoundingClientRect().top;
					if (distance > 0 && distance < closestDistance) {
						closestDistance = distance;
						closestCrmBlock = block;
					}
				});

				if (closestCrmBlock) {
					const crmId = closestCrmBlock.getAttribute('data-crm-id');
					button.setAttribute('data-crm-button-for', crmId);
				}
			});

			buttons.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScrollToAnchor(_sel);
		});

		if (document.querySelector('.rank-math-list-item')) {
			document.querySelectorAll('.rank-math-question').forEach((_el) => {
				_el.dataset.toggled = '0';
				_el.addEventListener('click', () => {
					toggleFAQ(_el);
				});
			});
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				new FarloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}
		if (document.querySelector('input[type="number"]')) {
			document.querySelectorAll('input[type="number"]').forEach((numberInput) => {
				new FarloUiNumberInput(numberInput);
			});
		}

		if (document.querySelector('.gfield_list_icons')) {
			document.querySelectorAll('.gfield_list_icons').forEach(function (buttonContainer) {
				new FarloUiList(buttonContainer);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}

		gsapParallax();
		gsapTransform();
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function (registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
